'use strict';

/**
 * Collection for the status
 *
 * @category   Collection
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var StatusModel = require('../models/status');

var StatusCollection = Collection.extend({
    name: 'collection:status',
    sortDefault: 'position.asc',
    model: StatusModel,

    initialize: function() {
        Collection.prototype.initialize.apply(this, arguments);

        this.listenTo(App.radio().vent, 'language:changed', this.reloadLanguages);
    },

    /**
     * Resets the translations, on language change
     */
    reloadLanguages: function() {
        this.each(function(model) {
            model.set('name', App.t('collection::object:details:object-status:' + model.id + ':label'))
        });
    },
});

module.exports = StatusCollection;